/**
 * Deterministic userId -> color for live-collab presence UI (per-line chips,
 * left-edge highlight in LexicalRichEditor). Same id always maps to the same
 * hue so a user's color stays stable across sessions/devices without a
 * lookup table. Palette is saturated but mid-lightness so it stays legible
 * as both chip background (dark text) and a low-alpha overlay tint on both
 * light and dark editor backgrounds.
 */

const PALETTE = [
  'hsl(261, 70%, 68%)', // violet
  'hsl(199, 80%, 60%)', // sky blue
  'hsl(160, 65%, 48%)', // teal green
  'hsl(35, 90%, 60%)',  // amber
  'hsl(340, 78%, 66%)', // pink
  'hsl(213, 75%, 65%)', // blue
  'hsl(285, 60%, 66%)', // purple
  'hsl(142, 55%, 52%)', // green
  'hsl(18, 85%, 62%)',  // orange
  'hsl(190, 65%, 55%)', // cyan
  'hsl(312, 60%, 66%)', // magenta
  'hsl(48, 80%, 56%)',  // gold
];

function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/** Deterministic color for a given user id. Falsy ids fall back to the first
 *  palette entry rather than throwing, so callers don't need to guard. */
export function userColor(userId) {
  const key = String(userId ?? '');
  if (!key) return PALETTE[0];
  return PALETTE[hashString(key) % PALETTE.length];
}

export default userColor;
